import React, { useState } from 'react';
import { PageHeader, Tab, Tabs } from '@keplerco/core';
import { TabType } from './roles.models';
import { RolesLayout } from './roles.layout';
import { RolesAdvancedLayout } from './roles.advanced.layout';

export function RolesPage(): JSX.Element {
  const [activeTabType, setActiveTabType] = useState<TabType>('Advanced');
  return (
    <div className="wrapper stack" style={{ gap: 30 }}>
      <PageHeader
        breadcrumbs={[{ name: 'Choose a role', url: window.location.pathname }]}
        title="Choose a role"
        subtitle="Find a job you are interested in."
      />
      <Tabs static>
      <Tab active={activeTabType === 'Advanced'} id="Advanced" name="Advanced search" onClick={() => setActiveTabType('Advanced')} />
        <Tab active={activeTabType === 'Search'} id="Search" name="Search roles" onClick={() => setActiveTabType('Search')} />
      </Tabs>
      {activeTabType === 'Search' ? <RolesLayout /> : <RolesAdvancedLayout />}
    </div>
  );
}
